<template>
  <div id="collectionA">
    <div class="bg-img"></div>

    <div class="content middle collection">
      <div class="cell">
        <div class="container relative">
          <div class="row">
            <div class="col-xs-12">
              <div class="row series_selection">
                <div :class="'col-xs-3 ' + key" v-for="(value, key) in series" :key="key">
                  <img :src="value.img" />
                  <div
                    class="button-b click font20 text-center"
                    :class="selected_series == key ? 'active shown-o' : textColor"
                    @click="selected_series = key">
                    {{ value.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16" @click="next()">
      <span class="orange click inlineb w10">
        NEXT
        <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";

export default {
  name: "Collection",
  data() {
    return {
      selected_series: "alba",
      series: {
        blackjack: {
          img : "images/collection/blackjack/BLACKJACK.png",
          label: "BLACK JACK",
        },
        aria: {
          img : "images/collection/aria/ARIA.png",
          label: "ARIA",
        },
        alba: {
          img: "images/collection/alba/ALBA.png",
          label: "ALBA",
        },
        axes: {
          img: "images/collection/axes/AXES.png",
          label: "AXES",
        }
      },
      textColor: 'white'
    };
  },
  created: function () {
    this.$parent.headerW();
    this.$parent.headerNoBg();
    this.$parent.footerB();
    this.$parent.footerW();
  },
  methods: {
    next() {
      if (this.selected_series == "blackjack") {
        this.$store.state.artwork = {
          type: "blackjack",
          frameColor: "mbb",
          keyColor: "mbb",
          format: "single",
          buttonFormat: "square",
          layout: "BB",
          leftSideLeftButton: "B",
          leftSideRightButton: "B",
          rightLayout: "SK",
          rightSideLeftButton: "SK",
          rightSideRightButton: null,
          tripleRightLayout: "SK",
          tripleRightSideLeftButton: "SK",
          tripleRightSideRightButton: null,
          iconSize: 8,
          rightIconSize: 8,
          tripleRightIconSize: 8,
          fontSize: 3.5,
          rightFontSize: 3.5,
          tripleRightFontSize: 3.5,
          protocol: "",
          productLine: "Classic",
          name: "BLACK JACK artwork",
          productCode: "",
          fontType: "Black Nova Metal",
          alignment: "topcenter",
          rightAlignment: "topcenter",
          tripleRightAlignment: "topcenter",
          layoutStyle: "iconOnly",
          rightLayoutStyle: "socket",
          tripleRightLayoutStyle: "socket",
          content: [],
          rightContent: [],
          tripleRightContent: [],
        };
      } else if (this.selected_series == "alba") {
        this.$store.state.artwork = {
          type: "alba",
          frameColor: "gb",
          keyColor: "gb",
          format: "single",
          leftSideLeftButton: "B",
          leftSideRightButton: "B",
          layout: "BB",
          rightSideLeftButton: "M1",
          rightSideRightButton: null,
          rightLayout: "M1",
          tripleRightSideLeftButton: "SK",
          tripleRightSideRightButton: null,
          tripleRightLayout: "SK",
          iconSize: 8,
          rightIconSize: 8,
          tripleRightIconSize: 8,
          fontSize: 2.5,
          rightFontSize: 2.5,
          tripleRightFontSize: 2.5,
          protocol: "",
          productLine: "Classic",
          name: "An ALBA artwork",
          productCode: "",
          fontType: "Avenir Black Nova",
          alignment: "topleft",
          rightAlignment: "topleft",
          tripleRightAlignment: "topleft",
          layoutStyle: "iconOnly",
          rightLayoutStyle: "iconOnly",
          tripleRightLayoutStyle: "socket",
          content: [],
          rightContent: [],
          tripleRightContent: [],
        };
      } else if (this.selected_series == "aria") {
        this.$store.state.artwork = {
          type: "aria",
          frameColor: "gb",
          format: "single",
          iconSize: 8,
          rightIconSize: 8,
          tripleRightIconSize: 8,
          fontSize: 2.5,
          rightFontSize: 2.5,
          tripleRightFontSize: 2.5,
          content: [],
          rightContent: [],
          tripleRightContent: [],
          protocol: "",
          productLine: "Classic",
          name: "An ARIA artwork",
          productCode: "",
          fontType: "Avenir Black Nova",
          alignment: "topLeft",
          rightAlignment: "topLeft",
          tripleRightAlignment: "topLeft",
          layout: "L12",
          leftSideLeftButton: "L12",
          leftSideRightButton: null,
          rightLayout: "L9",
          rightSideLeftButton: "L9",
          rightSideRightButton: null,
          tripleRightLayout: "SK",
          tripleRightSideLeftButton: "SK",
          tripleRightSideRightButton: null,
          layoutStyle: "iconOnly",
          rightLayoutStyle: "iconOnly",
          tripleRightLayoutStyle: "socket",
        };
      } else if (this.selected_series == "axes") {
        this.$store.state.artwork = {
          type: "axes",
          frameColor: "gb",
          format: "single",
          iconSize: 8,
          rightIconSize: 8,
          tripleRightIconSize: 8,
          fontSize: 2.5,
          rightFontSize: 2.5,
          tripleRightFontSize: 2.5,
          content: [],
          rightContent: [],
          tripleRightContent: [],
          protocol: "",
          productLine: "Classic",
          name: "An AXES artwork",
          productCode: "",
          fontType: "Avenir Black Nova",
          alignment: "topLeft",
          rightAlignment: "topLeft",
          tripleRightAlignment: "topLeft",
          layout: "N34",
          leftSideLeftButton: "N34",
          leftSideRightButton: null,
          rightLayout: "DR",
          rightSideLeftButton: "DR",
          rightSideRightButton: null,
          tripleRightLayout: "SK",
          tripleRightSideLeftButton: "SK",
          tripleRightSideRightButton: null,
          layoutStyle: "iconOnly",
          rightLayoutStyle: "iconOnly",
          tripleRightLayoutStyle: "socket",
        };
      }
      this.$store.commit("getProductCode");
      this.$store.commit("getContent");
      this.$store.commit("getRightContent");
      this.$store.commit("getTripleRightContent");
      this.$router.push({ path: "/collection/config" });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name != "addproduct-keypad") {
        vm.$store.state.newArtworkToProductId = null
      }
    });
  },
};
</script>

<style lang="css">
.header.black {
  border-bottom: none;
}
</style>
